module.exports = __webpack_public_path__ + "static/media/invoice_box.c8875ad0.svg";